import { parseFolderId } from './parsers/folder-id';
import { ItemKind } from '../../constants/ItemKind';
export function initFolder() {
  function getRequest(folderId) {
    const {
      mediaType
    } = parseFolderId(folderId);
    return Promise.resolve({
      data: {
        id: folderId,
        kind: ItemKind.Folder,
        source: 'shutterStock',
        name: 'Shutterstock',
        mediaType,
        filesCount: null,
        createdAt: null,
        parentId: null
      }
    });
  }
  return {
    get: getRequest
  };
}